<template>
  <div>
    <gat-tab :items="tabs" :show-in-toolbar="true" />
    <keep-alive>
      <router-view
        callId=""
        :portcallId="proformaStore.proformaWindow?.proformaInfo?.PORTCALL_ID || undefined"
        location="proforma"
        :proformaId="+props.proformaId"
        :parentId="+props.proformaId"></router-view>
    </keep-alive>
  </div>
</template>

<script setup lang="ts">
import { computed, onActivated, onUnmounted, onDeactivated } from 'vue';
import { useToolbarStore } from '@/store/toolbarStore';
// eslint-disable-next-line import/no-cycle
import { useProformaStore } from '@/modules/proforma/stores/proformaStore';
import { useApplicationStore } from '@/store/applicationStore';

const proformaStore = useProformaStore();
const toolbarStore = useToolbarStore();
const applicationStore = useApplicationStore();

const props = defineProps<{
  proformaId: string | number;
}>();

const tabs = computed(() => {
  const result = [];
  if (
    applicationStore.globalSettings?.SGL_USE_INQUIRY === 1 &&
    applicationStore.user.internal &&
    applicationStore.userRight('PR2.ACCESS')
  ) {
    result.push({ caption: 'DETAILS', routeName: 'proformaDetails' });
    result.push({ caption: 'DOCUMENTS', routeName: 'proformaDocs' });
    result.push({ caption: 'EMAILS', routeName: 'proformaEmailList' });
  }
  return result;
});

onActivated(async () => {
  await proformaStore.fetchProformaWindow(props.proformaId);
  toolbarStore.setToolbarTitle(
    `${proformaStore.proformaWindow?.proformaInfo?.PROFORMA_NUMBER} (${proformaStore.proformaWindow?.proformaInfo?.VESSEL_NAME})`
  );
});

onUnmounted(() => {
  toolbarStore.setBackNavigation(undefined);
  toolbarStore.setToolbarTitle('');
});

onDeactivated(() => {
  toolbarStore.setBackNavigation(undefined);
  toolbarStore.setToolbarTitle('');
});
</script>
<style scoped></style>
